<!-- /* ALTERADO PELA PGE-RS:
a) Deixando o login automático: se tem números, é CPF; se não é pela rede.
b) Ajuste de labels.
c) Alteração de lugares de alguns componentes.
d) Remoção da opção para add usuário externo.
*/ -->
<div class="login-form-wrapper" *ngIf="!loadingConfig && config && !config.error">
    <div class="login-form" [@animate]="{value:'*', params:{duration:'300ms',y:'100px'}}" style="border-radius: 14px; padding-top: 34px; padding-bottom: 14px;">
        <center>
            <img src="assets/images/pge_60anos/PGE_Vertical_semdecodificador_cor_positivo.png" alt="PGE/RS" style="width: 100%; height: auto; max-width: 200px;"/>
        </center>

        <br/>

        <form name="form" [formGroup]="form" novalidate>

            <mat-form-field appearance="outline" class="mb-3" *ngIf="config.tiposLogin.includes('login_ldap_ativo') || config.tiposLogin.includes('login_interno_ativo')" >
                <mat-label>{{form.get('tipoLogin').value === 'ldap' ? 'Usuário da Rede (ou CPF)' : 'CPF (ou usuário da rede)'}}</mat-label>
                <input class="mt-1" style="font-size: 1.1em; height: 16px;" matInput ui-mask="999.999.999-99" formControlName="username" (keyup)="onChangeTipoLogin2()" autofocus>
                <mat-icon matSuffix class="text-secondary">person</mat-icon>
                <!--
                <mat-error *ngIf="form.get('username').hasError('required')">
                    {{form.get('tipoLogin').value === 'ldap' ? 'Usuário da Rede' : 'CPF'}} é obrigatório
                </mat-error>
                <mat-error
                    *ngIf="!form.get('username').hasError('required') &&
                                form.get('username').hasError('username')">
                    Entre com um {{form.get('tipoLogin').value === 'ldap' ? 'Usuário da Rede' : 'CPF'}} válido
                </mat-error>
                -->
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="config.tiposLogin.includes('login_ldap_ativo') || config.tiposLogin.includes('login_interno_ativo')">
                <mat-label>Senha {{form.get('tipoLogin').value === 'ldap' ? 'da Rede' : 'do CPF'}}</mat-label>
                <input class="mt-1" style="font-size: 1.1em; height: 16px;" matInput type="password" formControlName="password">
                <mat-icon matSuffix class="text-secondary">vpn_key</mat-icon>
                <!--
                <mat-error>
                    Senha é obrigatório
                </mat-error>
                -->
            </mat-form-field>

            <div *ngIf="errorMessage" class="flex flex-row xs:flex-col self-center">
                <mat-error>
                    {{errorMessage}}
                </mat-error>
            </div>

            <button *ngIf="config.tiposLogin.includes('login_ldap_ativo') || config.tiposLogin.includes('login_interno_ativo')" (click)="submit()" mat-raised-button [color]="'primary'" class="submit-button" aria-label="login"
                    [disabled]="form.invalid">
                ACESSAR O SUPP
            </button>

			<!-- /* ALTERADO PELA PGE-RS: código abaixo comentado.
            <div *ngIf="config.tiposLogin.includes('login_ldap_ativo') && config.tiposLogin.includes('login_interno_ativo') && !!config.ldap"
                 class="remember-forgot-password flex flex-row xs:flex-col justify-between items-center content-center">

                <a class="forgot-password" (click)="onChangeTipoLogin(form.get('tipoLogin').value === 'ldap' ? 'interno' : 'ldap')">
                    {{form.get('tipoLogin').value === 'ldap' ? 'Logar com credenciais do sistema?' : 'Logar com credenciais ' + config.ldap + '?'}}
                </a>
            </div>

            <a *ngIf="config.tiposLogin.includes('login_govbr_ativo') && config.govBR?.client_id" mat-raised-button
               [href]="config.govBR?.sso_url+'/authorize?response_type=code&client_id='+config.govBR?.client_id+'&scope=openid+email+phone+profile+govbr_confiabilidades&redirect_uri='+config.govBR?.redirect_uri"
               class="submit-button gov-br" aria-label="entrar com gov.br">
               Entrar com <strong style="color: #1351b4">gov.br</strong>
            </a>*/ -->

        </form>

        <div style="padding: 14px;">
            <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
        </div>

        <form style="text-align: center;">
            <div *ngIf="config.tiposLogin.includes('login_interno_ativo')" class="remember-forgot-password">
                <a class="forgot-password" [routerLink]="'/auth/esqueci-senha'" style="font-weight: 300 !important;">
                    Alterar a senha do CPF?
                </a>
            </div>
            <div class="remember-forgot-password mt-2">
                <a class="forgot-password" href="javascript:void(0)" (click)="esqueceuSenhaRede()" style="font-weight: 300 !important;">
                    Alterar a senha da Rede?
                </a>
            </div>
        </form>

        <div class="subtitle mt-5" style="border-top: 1px dashed; color: lightgray;"></div>

        <div style="font-weight: 300 !important;">
            <div *ngIf="!version || (version && (version === config.version))" class="subtitle mt-5">{{config.version}}</div>
            <div *ngIf="version && version !== config.version" class="subtitle mt-4">{{version}}f/{{config.version}}b</div>

            <!-- ALTERADO PELA PGE/RS: adicionada a versão da implantação. -->
            <div class="subtitle" id="versao_pge">18.07.25_09h00</div>
            <div class="subtitle mb-5">[ {{config.environment | uppercase}} ]</div>
        </div>
    </div>
</div>
